import { Asterisk } from 'lucide-react';

export default function Marquee({ items, dark = true }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className={`whitespace-nowrap font-serif text-3xl italic md:text-5xl ${i % 2 === 0 ? (dark ? 'text-white' : 'text-ink') : 'text-transparent'}`}
            style={i % 2 === 1 ? { WebkitTextStroke: `1.5px ${dark ? '#C9A227' : '#8a7020'}` } : undefined}>
            {t}
          </span>
          <Asterisk className="mx-6 h-6 w-6 shrink-0 text-gold md:mx-10 md:h-8 md:w-8" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y py-8 ${dark ? 'border-white/10 bg-ink' : 'border-black/10 bg-white'}`}>
      <div className="marquee-track">{row(false)}{row(true)}</div>
    </div>
  );
}
